import clsx from 'clsx';
import { I18nLink, Button } from '@stape-io/promo-shared-content';

import styles from './HeaderWithArrow.module.scss';

interface HeaderWithArrowProps {
  href: string;
  isOpen: boolean;
  isActive: boolean;
  title: string;
  onToggle: () => void;
}

export function HeaderWithArrow({ href, isOpen, isActive, title, onToggle }: HeaderWithArrowProps) {
  return (
    <div className={clsx(styles.header, { 'text-bold': isActive })}>
      <Button size="xs" color="transparent" className={styles.arrow} onClick={onToggle}>
        <svg
          className={clsx(styles.arrowIcon, { [styles.open]: isOpen })}
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path d="M9 13.852L13.592 11.64L9 9.428V8L15.356 11.122V12.144L9 15.266V13.852Z" />
        </svg>
      </Button>
      <I18nLink href={href} className={clsx(styles.title, { 'text-bold': isActive })}>
        {title}
      </I18nLink>
    </div>
  );
}
